import styled, { css, keyframes } from "styled-components";

// 스켈레톤 shimmer 애니메이션
const shimmer = keyframes`
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
`;

const shimmerEffect = css`
  background: linear-gradient(
    90deg,
    rgb(231, 231, 231) 25%,
    #e0e0e0 50%,
    #f0f0f0 75%
  );
  background-size: 200% 100%;
  animation: ${shimmer} 1.5s infinite;
`;

export const SkeletonContainer = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

interface SkeletonElementProps {
  width?: string;
  height?: string;
  marginTop?: string;
  ratio?: string;
}

export const SkeletonBox = styled.div<SkeletonElementProps>`
  ${shimmerEffect}
  width: ${(props) => props.width || "100%"};
  height: ${(props) => props.height || "16px"};
  border-radius: 4px;
  margin-top: ${(props) => props.marginTop || "0"};
`;

export const SkeletonText = styled.div<SkeletonElementProps>`
  ${shimmerEffect}
  width: ${(props) => props.width || "100%"};
  height: ${(props) => props.height || "14px"};
  border-radius: 4px;
  margin-top: ${(props) => props.marginTop || "0"};
  aspect-ratio: ${(props) => props.ratio || "none"};
`;

export const SkeletonButton = styled.div`
  ${shimmerEffect}
  width: 24px;
  height: 24px;
  border-radius: 50%;
`;

export const SkeletonImage = styled.div`
  ${shimmerEffect}
  width: 64px;
  height: 64px;
  border-radius: 8px;
  flex-shrink: 0;
`;

export const SkeletonBadge = styled.div<SkeletonElementProps>`
  ${shimmerEffect}
  width: ${(props) => props.width || "60px"};
  height: ${(props) => props.height || "20px"};
  border-radius: 12px;
  margin-top: ${(props) => props.marginTop || "0"};
`;
